import { render, staticRenderFns } from "./pause-square.vue?vue&type=template&id=8af5b5e6&scoped=true&"
import script from "./pause-square.vue?vue&type=script&lang=js&"
export * from "./pause-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af5b5e6",
  null
  
)

export default component.exports